<template>
  <div class="list-item invitation-item">
    <v-list-item-avatar tile v-if="!isMobile">
      <div>
        <svg
          width="29"
          height="29"
          viewBox="0 0 29 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="1"
            y="1"
            width="27"
            height="5"
            rx="2"
            stroke="black"
            stroke-width="2"
          />
          <rect
            x="1"
            y="10"
            width="27"
            height="8"
            rx="2"
            stroke="black"
            stroke-width="2"
          />
          <rect
            x="1"
            y="23"
            width="27"
            height="5"
            rx="2"
            stroke="black"
            stroke-width="2"
          />
        </svg>
      </div>
    </v-list-item-avatar>
    <v-list-item-content>
      <div class="item-right">
        <div
          class="description d-flex flex-grow-1"
          :class="{ 'flex-row': !isMobile }"
        >
          <div class="d-flex flex-column">
            <span class="font-weight-bold mb-1">{{
              invitation.user | fullName
            }}</span>
            <span>{{ invitation.interviewFormat.interviewName }}</span>
          </div>
          <div class="d-flex flex-column align-end">
            <Chip class="chip--status" shrink :color="statusColor">
              {{ invitation.status | upperCase }}
            </Chip>
            <span class="secondary-text mt-1">
              Invited {{ invitation.createdAt | date }}
            </span>
          </div>
        </div>
      </div>
    </v-list-item-content>
  </div>
</template>

<script>
import Chip from "@/components/common/Chip";
import { formatDate } from "@/utils/time";
import { LONG_DATE_FORMAT } from "@/constants/common.js";

export default {
  name: "ReportListItem",
  components: {
    Chip
  },
  props: {
    invitation: {
      type: Object,
      required: true
    }
  },
  computed: {
    statusColor() {
      return this.invitation.status === "scheduled" ? "green" : "yellow";
    }
  },
  filters: {
    date(date) {
      return formatDate({
        date,
        endFormat: LONG_DATE_FORMAT
      });
    }
  }
};
</script>

<style lang="scss">
.invitation-item {
  line-height: normal;

  .v-avatar.v-list-item__avatar {
    background-color: rgba($default-line, 0.15) !important;
  }
}
</style>
